const CORVETTE_HOST = process.env.CORVETTE_HOST;
type SearchParams = {
  [key: string]: any;
};
export const refRegistrationParams = {
  loansAllPurpose: '/loans/prequal/allpurpose',
  creditCards: '/mfe/member/credit-cards/offers',
  carGarage: '/auto-garage/detail',
  smartMoney: '/mfe/money/onboarding',
  boostOnboarding: '/mfe/cpd/boost/onboarding',
  monCreateAccount: '/mfe/money/create-account',
};
export const registrationPath = {
  registration: '/registration',
  getStarted: '/registration/getStarted',
  loginIndex: '/login/index',
};
export const formRegistrationUrl = (params: SearchParams, url = registrationPath.getStarted) => {
  const defaultParams = { br: 'exp' };
  const allParams = { ...defaultParams, ...params };
  return `${CORVETTE_HOST}${url}?${new URLSearchParams(allParams).toString()}`;
};
